import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ReleaseNotes from 'feature/release-notes/ReleaseNotes';

const ReleaseNotesRoutes = () => {
  return (
    <>
      <Routes>
        <Route element={<ReleaseNotes />} index />
      </Routes>
    </>
  );
};

export default ReleaseNotesRoutes;
